// client/src/components/comunicacao/automatica/ComunicacaoAutomaticaRow.js
import React from 'react';
import { MoreVertical, Mail, MessageCircle, Smartphone, Calendar } from 'lucide-react';
import PropTypes from 'prop-types'; // ✅ Importar PropTypes
import { useMutateComunicacaoConfig } from '../../../hooks/useComunicacaoConfig';

const ComunicacaoAutomaticaRow = ({ config, onOpenActions, isDeleting }) => {
    // ✅ Liga/desliga o envio automático sem precisar excluir e recriar a
    // config — server/services/comunicacaoConfigService.js só considera
    // configs com ativo:true (ou sem o campo, pra configs antigas).
    const { updateConfig } = useMutateComunicacaoConfig();
    // ativo === false é a ÚNICA condição que desliga (undefined/true = ligado
    // — mesma regra do backend, pra configs criadas antes deste campo existir).
    const ativo = config.ativo !== false;

    const getCanalIcon = (canal) => {
        switch (canal) {
            case 'WhatsApp': return <MessageCircle size={16} className="text-green-600" />;
            case 'Email': return <Mail size={16} className="text-blue-600" />;
            case 'SMS': return <Smartphone size={16} className="text-purple-600" />;
            default: return <MessageCircle size={16} />;
        }
    };

    // ✅ Cada domínio tem seu próprio vocabulário de evento — ver
    // EVENTOS_POR_DOMINIO em server/models/ComunicacaoConfig.js.
    const EVENTO_LABELS = {
        Agendado: 'Agendado', Confirmado: 'Confirmado', Pendente: 'Pendente', Concluido: 'Concluído', Cancelado: 'Cancelado', NoShow: 'Falta sem aviso (No-show)',
        confirmado: 'Confirmado', enviado: 'Enviado', entregue: 'Entregue', cancelado: 'Cancelado',
        conta_criada: 'Conta Criada', conta_cancelada: 'Conta Cancelada', pagamento_pendente: 'Pagamento Pendente',
        vencimento_de_plano: 'Vencimento de Plano', esqueci_senha: 'Esqueci Senha',
        cadastro_confirmacao: 'Confirmação de Cadastro (Cliente)', recuperacao_senha: 'Recuperação de Senha (Cliente)',
        aniversario: 'Aniversário do Cliente',
        agendamentos_do_dia: 'Agendamentos do Dia'
    };
    const getEventoLabel = (evento) => EVENTO_LABELS[evento] || evento;

    return (
        <tr className="hover:bg-gray-50">
            <td className="py-3">
                <div className="flex items-center">
                    <div className="ml-3">
                        <p className="text-sm font-medium text-gray-900">
                            {config.nome || 'Configuração sem nome'}
                        </p>
                        <p className="text-sm text-gray-500">
                            {config.dominio || 'Agendamento'}
                        </p>
                    </div>
                </div>
            </td>
            
            <td className="py-3">
                <div className="flex items-center">
                    <Calendar size={16} className="text-gray-600 mr-2" />
                    <span className="text-sm text-gray-900">{getEventoLabel(config.evento)}</span>
                </div>
            </td>
            
            <td className="py-3">
                <div className="flex items-center">
                    {getCanalIcon(config.canal)}
                    <span className="ml-2 text-sm text-gray-900">{config.canal}</span>
                </div>
            </td>
            
            <td className="py-3">
                <label className="toggle-switch" title={ativo ? 'Desativar envio automático' : 'Ativar envio automático'}>
                    <input
                        type="checkbox"
                        checked={ativo}
                        disabled={updateConfig.isPending}
                        onChange={(e) => updateConfig.mutate({ id: config._id, data: { ativo: e.target.checked } })}
                    />
                    <span className="toggle-slider" />
                </label>
            </td>

            <td className="text-right">
                <button
                    onClick={() => onOpenActions(config)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={isDeleting}
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

// ✅ Adicionado PropTypes
ComunicacaoAutomaticaRow.propTypes = {
    config: PropTypes.shape({
        _id: PropTypes.string,
        nome: PropTypes.string,
        tipo: PropTypes.string,
        evento: PropTypes.string,
        canal: PropTypes.string,
        template: PropTypes.shape({
            nome: PropTypes.string,
        }),
        createdAt: PropTypes.string,
        ativo: PropTypes.bool,
    }).isRequired,
    onOpenActions: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool,
};

ComunicacaoAutomaticaRow.defaultProps = {
    isDeleting: false,
};

export default ComunicacaoAutomaticaRow;